import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CATEGORIES } from "@/data/media";
import { Reveal } from "@/components/Reveal";

export const CategoryCards = () => (
  <section className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="category-section">
    <Reveal className="text-center mb-12">
      <h2 className="font-serif text-3xl lg:text-4xl text-charcoal">Shop by Category</h2>
      <div className="w-16 h-px bg-gold mx-auto mt-5" />
    </Reveal>

    <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8">
      {CATEGORIES.map((cat, i) => (
        <Reveal key={cat.slug} delay={i * 0.08}>
          <Link
            to={`/shop/${cat.slug}`}
            data-testid={`category-card-${cat.slug}`}
            className="group flex flex-col items-center text-center gap-3"
          >
            <h3 className="font-sans font-medium text-lg sm:text-xl uppercase tracking-[0.12em] text-charcoal group-hover:text-pink transition-colors duration-300">
              {cat.name}
            </h3>
            <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.16em] text-pink">
              Shop Now
              <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
            </span>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
